import { render, staticRenderFns } from "./SchoolManagePage.vue?vue&type=template&id=5c5421b7&scoped=true"
import script from "./SchoolManagePage.vue?vue&type=script&lang=js"
export * from "./SchoolManagePage.vue?vue&type=script&lang=js"
import style0 from "./SchoolManagePage.vue?vue&type=style&index=0&id=5c5421b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5421b7",
  null
  
)

export default component.exports